export default "__VITE_ASSET__CVUMUeGz__"